import { BasketItemType, basketItemTypeSchema } from '@common/interfaces/nexudus/api/rest/Basket';
import z from 'zod';

/**
 * Interface for an item in the user's basket.
 *
 * This has initially been cribbed from AnalyticsBasketItem in passport for simplicity.
 *
 * It will probably need to be extended in future to meet the needs of the CRM team. A much
 * richer representation is available in common/interfaces/nexudus/api/rest/Basket.ts as BasketBookingData and
 * related interfaces, but it would be a lot more work to construct these.
 */
export interface EventEntryBasketItem {
  item_id: string;
  item_name: string;
  item_category: BasketItemType;
  price?: number;
  quantity?: number;
}

export const eventEntryBasketItemSchema = z.object({
  item_id: z.string(),
  item_name: z.string(),
  item_category: basketItemTypeSchema,
  price: z.number().optional(),
  quantity: z.number().optional(),
});
